/*
 * wps 客户端api
 *
 * (c) 2017/8/4 lihaozhou
 * Email: lihaozhou@wps.cn
 * License: KSO
 */
import execService from './../exec';

class Wpsoffice {
  constructor() {
    this.apiPrefix = 'common.wpsoffice';

    this.apis = {
      openApp: `${this.apiPrefix}.openApp`,
      screenShot: `${this.apiPrefix}.screenShot`,
      getAppInfo: `${this.apiPrefix}.getAppInfo`,
      search: `${this.apiPrefix}.search`
    };
  }

  /**
   * 打开app
   * @param appName
   */
  openApp(appName) {
    execService.exec(this.apis.openApp, [appName]);
  }

  /**
   * 截图
   * @returns {Promise}
   */
  screenShot(path) {
    path = path || '';

    return new Promise((resolve, reject) => {
      execService.exec(this.apis.screenShot, {path: path}, (error, response) => {
        if (error) {
          reject(error);
        } else {
          if (response.name && response.path) {
            resolve({
              name: response.name,
              path: response.path,
              size: response.size
            });
          } else {
            reject(new Error('screen shot was cancelled'));
          }
        }
      });
    });
  }

  /**
   * 获取客户端信息
   * @returns {Promise}
   */
  getAppInfo() {
    return execService.execPromise(this.apis.getAppInfo);
  }

  /**
   * 搜索
   * @returns {Promise}
   */
  search(keyword) {
    const params = [keyword];

    return new Promise((resolve, reject) => {
      execService.exec(this.apis.search, params, (error, response) => {
        if (error) {
          reject();
        } else {
          resolve(response);
        }
      });
    });
  }
}

export default new Wpsoffice();
